var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { DeleteOutlined } from '@ant-design/icons';
import { useMixpanel, useService } from '@tenderd/track-web-utils';
import { Button, Popconfirm, message } from 'antd';
import React, { useState } from 'react';
import { useGroupGeofencePageContext } from '../../../../GroupGeofencePage.context';
var DeleteLocationMarker = function (props) {
    var context = useGroupGeofencePageContext();
    var _a = __read(useState(false), 2), loading = _a[0], setLoading = _a[1];
    var service = useService();
    var mixpanel = useMixpanel();
    var onArchiveGeofence = function () {
        setLoading(true);
        service.server
            .deleteGroupGeofenceLocationMarker(context.selectedGeofence._id, props.locationId)
            .then(function () {
            message.success('Location deleted successfully');
            mixpanel.track('Location marker deleted', { extension: 'track' });
            var res = __assign(__assign({}, context.selectedGeofence), { locationMarkers: context.selectedGeofence.locationMarkers.filter(function (item) { return item._id !== props.locationId; }) });
            context.updateGeofenceData('update', res);
            context.setSelectedGeofence(res);
            props.onSuccess();
        })
            .finally(function () {
            setLoading(false);
        });
    };
    if (!props.locationId)
        return React.createElement(React.Fragment, null);
    return (React.createElement(Popconfirm, { title: "Archive Group?", description: "Are you sure you want to archive this group?", onConfirm: onArchiveGeofence, okText: "Yes", cancelText: "No" },
        React.createElement(Button, { type: "text", danger: true, loading: loading },
            "Delete Marker ",
            React.createElement(DeleteOutlined, null))));
};
export default DeleteLocationMarker;
